import { createContext } from 'react';

const ErrorHandlerContext = createContext(err => {
    console.error(err);
});

export { ErrorHandlerContext };
